import { Roles, type RoleName } from '@/router/roles';

interface RoleDestination {
	redirectPath: string;
	fallbackRouteName: string;
}

const DESTINATIONS_BY_ROLE: Partial<Record<RoleName, RoleDestination>> = {
	[Roles.EVERGREEN]: { redirectPath: '/app/employee', fallbackRouteName: 'Group Signups' },
	[Roles.DEVELOPER]: { redirectPath: '/app/employee', fallbackRouteName: 'Group Signups' },
	[Roles.REFADMIN]: { redirectPath: '/app/admin', fallbackRouteName: 'Admin' },
	[Roles.ASSIGNOR]: { redirectPath: '/app/assignor', fallbackRouteName: 'Assignors Dashboard' },
	[Roles.OFFICIAL]: { redirectPath: '/app/officials', fallbackRouteName: 'Officials Dashboard' },
	[Roles.CLUB_ADMINISTRATOR]: { redirectPath: '/app/client', fallbackRouteName: 'Client Dashboard' },
	[Roles.CLUB_SCHEDULER]: { redirectPath: '/app/client/games', fallbackRouteName: 'Client Games' }
};

const AUTH_REDIRECT_PRIORITY = [Roles.EVERGREEN, Roles.DEVELOPER, Roles.REFADMIN, Roles.ASSIGNOR, Roles.OFFICIAL, Roles.CLUB_ADMINISTRATOR, Roles.CLUB_SCHEDULER] as const;
const ROUTER_FALLBACK_PRIORITY = [Roles.REFADMIN, Roles.EVERGREEN, Roles.DEVELOPER, Roles.ASSIGNOR, Roles.OFFICIAL, Roles.CLUB_ADMINISTRATOR, Roles.CLUB_SCHEDULER] as const;
const USER_DESTINATION = { redirectPath: '/app/user', fallbackRouteName: 'User' } as const;

function getDefaultDestinationForRoles(roles: string[], priority: readonly RoleName[]): RoleDestination {
	const userRoles = new Set(Array.isArray(roles) ? roles : []);
	const matchingRole = priority.find((role) => userRoles.has(role));
	return (matchingRole ? DESTINATIONS_BY_ROLE[matchingRole] : null) ?? USER_DESTINATION;
}

export function getDefaultRedirectPathForRoles(roles: string[] = []): string {
	return getDefaultDestinationForRoles(roles, AUTH_REDIRECT_PRIORITY).redirectPath;
}

export function getDefaultRouteNameForRoles(roles: string[] = []): string {
	return getDefaultDestinationForRoles(roles, ROUTER_FALLBACK_PRIORITY).fallbackRouteName;
}
